import SelectorFilter from "../typescript/modules/selector-filter";
import ShowMoreText from "../typescript/modules/show-more-text";
import SlideToggle from "../typescript/modules/slide-toggle";
import Slideshow from "../typescript/modules/slideshow";
import ListExpander from "../typescript/modules/list-expander";
import IconNavigation from "../../../../Site/gulp/scripts/typescript/modules/icon-navigation";
import RevealContent from "../typescript/modules/reveal-content";

const showMoreTriggers = SelectorFilter.excludeByClass(document.querySelectorAll('.js-show-more-text'), 'js-show-more-text-done');
for (let i = 0; i < showMoreTriggers.length; i++) {
	new ShowMoreText(showMoreTriggers[i]);
}

new SlideToggle();
(<any>window).ListExpander = ListExpander;

const slideshows = document.querySelectorAll('.js-slideshow') as NodeListOf<HTMLElement>;

for (let i = 0; i < slideshows.length; i++) {
	new Slideshow(slideshows[i]);
}

const iconNavigations = document.querySelectorAll('.js-icon-navigation') as NodeListOf<HTMLDivElement>;

for (let i = 0; i < iconNavigations.length; i++) {
	new IconNavigation(iconNavigations[i]);
}

(<any>window).RevealContent = RevealContent;
